// NoteList (Domain/Inbox; was InboxViews.tsx's, BL-189): the notifications (notifications.list) by
// group, newest first, each opening where it's dealt with. A group is its label and count over its
// rows, a hairline between groups. A row has a mark before it (filled while unread, red when urgent, an
// outline once read), when it came and whether it's unread over its title, what it says under it, and
// Mark read at its end while it's unread. It draws ready-to-show words (inbox-schemas.ts). Opening and
// marking read are the screen's callbacks, drawn only when it passes them. Reads only --notelist-*;
// Link reads its own.
import type { NoteListProps } from '../../inbox-schemas.ts';
import { Link } from '../Link/Link.tsx';
import './NoteList.css';

export function NoteList({
  data,
  onOpen,
  onMarkRead,
  busy,
}: {
  data: NoteListProps;
  /** Opens a notification's place (and marks it read): the screen's. */
  onOpen?: (id: string) => void;
  /** Mark one read: the screen's (notifications.markRead). */
  onMarkRead?: (id: string) => void;
  /** The one being marked. */
  busy?: string | null;
}) {
  if (!data.groups.length)
    return (
      <p className="fl-notelist__empty" role="status">
        Nothing needs you right now. Jobs ready for review, payments online, tasks given to you and what a
        customer asks land here.
      </p>
    );
  return (
    <div className="fl-notelist">
      {data.groups.map((g) => (
        <div key={g.key} className="fl-notelist__group" role="group" aria-label={g.label}>
          <h3 className="fl-notelist__head">
            {g.label} <span className="fl-notelist__cnt">{g.notes.length}</span>
          </h3>
          <ul className="fl-notelist__rows">
            {g.notes.map((n) => {
              const kind = n.read ? 'read' : n.urgent ? 'urgent' : 'new';
              return (
                <li key={n.id} className="fl-notelist__row" data-kind={kind}>
                  <span className="fl-notelist__main">
                    {/* unread: a filled mark, red only when it's urgent; read: an outline */}
                    <svg className="fl-notelist__mark" viewBox="0 0 10 10" aria-hidden="true">
                      <circle cx="5" cy="5" r="4" />
                    </svg>
                    <span>
                      <span className="fl-notelist__sub">
                        {n.time}
                        {kind === 'read' ? '' : kind === 'urgent' ? ', urgent' : ', unread'}
                      </span>
                      {onOpen ? (
                        <button type="button" className="fl-notelist__open" onClick={() => onOpen(n.id)}>
                          {n.title}
                        </button>
                      ) : (
                        <b className="fl-notelist__open">{n.title}</b>
                      )}
                      {n.body && <span className="fl-notelist__sub">{n.body}</span>}
                    </span>
                  </span>
                  {!n.read && onMarkRead && (
                    <Link onPress={() => onMarkRead(n.id)} label={`Mark read: ${n.title}`}>
                      {busy === n.id ? 'Marking…' : 'Mark read'}
                    </Link>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </div>
  );
}
